import React, { useMemo } from 'react';
import Descriptions from '@uiw/react-descriptions';
import { Badge } from 'react-bootstrap';
import StatusBadge from '../StatusBadge';

function Purchase({ vendorType, order, isDetailPage = false }) {
  const hideVendorPortalStatus = useMemo(() => {
    if (vendorType && vendorType.toLowerCase() === 'warehouse') {
      if (order.vendorPortalStatusCaption === 'Confirmation Sent to Vendor') {
        return true;
      }
    }
    return false;
  }, [vendorType, order]);

  return (
    <Descriptions bordered size={isDetailPage ? 'large' : 'default'} colon={!isDetailPage}>
      <Descriptions.Item label="Purchase Order #">{order.docNo}</Descriptions.Item>
      <Descriptions.Item label=" External Doc #">{order.vndrShpmntNo}</Descriptions.Item>
      <Descriptions.Item label="PO Status">
        <StatusBadge status={order.status} />
      </Descriptions.Item>
      <Descriptions.Item label="Receipt Date">{order.ExpectedReceiptDate}</Descriptions.Item>

      <Descriptions.Item label="Incoterms">{order.incoterms}</Descriptions.Item>
      {!isDetailPage ? (
        <Descriptions.Item label="No of Lines">{order.itemCount}</Descriptions.Item>
      ) : (
        <Descriptions.Item label="Vendor Code">{order.vendorNo}</Descriptions.Item>
      )}
      <Descriptions.Item label="Supplier Name" span={2}>
        {order.vendorName}
      </Descriptions.Item>
      <Descriptions.Item label="PBETT" span={1}>
        {order.scheduledForPosting ? (
          <Badge variant="success">Scheduled</Badge>
        ) : (
          <Badge variant="danger">Pending</Badge>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Receiving Location" span={2}>
        {order.locationName}
      </Descriptions.Item>
      <Descriptions.Item label="Shipping Method">
        {order.vpFreightType === 'SeaRailAir' ? 'SeaRailAir' : 'Truck'}
      </Descriptions.Item>
      {!hideVendorPortalStatus && (
        <Descriptions.Item label="Vendor Portal Status" span={3}>
          {order.vendorPortalStatusCaption}
        </Descriptions.Item>
      )}
    </Descriptions>
  );
}

export default Purchase;
